import {Exclude, Expose} from "class-transformer";
import {AbstractApiModel} from "./abstract.api.model";

@Exclude()
export class HashtagApiModel extends AbstractApiModel {
  @Expose() public id: number;
  @Expose() public name: string;
}
